import React from 'react';
import { childrenFlatMap } from '@tanium/coreui-utils';
import { Button } from '@tanium/react-button';
import { Stack, StackChild } from '@tanium/react-stack';
import { useTranslation } from './localization';

export interface Props {
  children?: React.ReactNode;
  cancelButtonLabel?: React.ReactNode;
  submitButtonLabel?: React.ReactNode;
  onCancelButtonClick?: React.MouseEventHandler;
  submitButtonDisabled?: boolean;
}

export const FormButtons = ({
  cancelButtonLabel,
  submitButtonLabel,
  onCancelButtonClick,
  submitButtonDisabled,
  children,
}: Props) => {
  const { t } = useTranslation();

  const resolvedChildren = children ?? (
    <>
      <Button type="submit" disabled={submitButtonDisabled}>
        {submitButtonLabel ?? t('Save')}
      </Button>
      {onCancelButtonClick && (
        <Button variant="secondary" type="button" onClick={onCancelButtonClick}>
          {cancelButtonLabel ?? t('Cancel')}
        </Button>
      )}
    </>
  );
  return (
    <Stack itemSpacing={1}>
      {childrenFlatMap(
        resolvedChildren,
        (child, i) => child && <StackChild key={i}>{child}</StackChild>,
      )}
    </Stack>
  );
};
